import request from '@/utils/request'

export function add(disease) {
  return request({
    url: '/InfoDisease/addData',
    method: 'post',
    data: disease
  })
}

export function edit(disease) {
  return request({
    url: '/InfoDisease/editData',
    method: 'post',
    data: disease
  })
}

export function getById(id) {
  return request({
    url: `/InfoDisease/getById/${id}`,
    method: 'post'
  })
}
